/**
 * Imágenes del Pórtico que resuelve el FRONT por `id` (GEN-11, Guo 2026-07-17):
 * hoy, solo el logo del tenant, con el mismo patrón que los colores
 * (agent-colors.js): data-driven en el cliente, cero ramas por tenant.
 *
 * Convención de assets (public/):
 *   - Tenant: /logos/<tenant-id>.svg  y  /logos/<tenant-id>-dark.svg
 *
 * Las FOTOS de los agentes ya no viven aquí (GEN-AG-006): son la foto en vigor
 * de la ficha de cada agente, que el kernel sirve y context/FotosAgentes.jsx
 * pinta. Se retiraron las fotos estáticas de public/avatars y `avatarUrlOf`.
 * Si `branding.logo_url` llegara del kernel, se ignora; si el fichero no
 * existe, TenantLogo cae a la inicial sin romper el layout.
 */

// Logo del tenant por id y tema — espejo de agentColorOf(palette, id, theme):
// la variante -dark existe porque una tinta oscura desaparece sobre el tema
// oscuro. Sin tenant -> null (insignia con la inicial).
export function tenantLogoOf(tenant, theme /* 'light'|'dark' */) {
  const id = tenant?.id
  if (!id) return null
  return `/logos/${encodeURIComponent(id)}${theme === 'dark' ? '-dark' : ''}.svg`
}
